import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Rocket, ShieldCheck, Star, Users } from 'lucide-react';
import { Button, Sticker } from './ui';
export const StickyTopBar = () => <div className="bg-brand-pink text-white text-center py-2 px-4 font-semibold text-sm md:text-base sticky top-0 z-50 shadow-md" data-id="element-192">
    🔥 OFERTA POR TIEMPO LIMITADO — 94% OFF
  </div>;
export const Hero = () => {
  return <section className="relative pt-12 pb-20 md:pt-20 md:pb-32 overflow-hidden bg-gradient-to-b from-white to-brand-gray" data-id="element-193">
      {/* Background Blobs */}
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-brand-blue/5 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-194" />
      <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-brand-pink/5 rounded-full blur-3xl translate-x-1/3 translate-y-1/3" data-id="element-195" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-196">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-197">
          {/* Left Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="text-center lg:text-left" data-id="element-198">
            <div className="inline-flex items-center gap-2 bg-brand-yellow/20 text-brand-orange font-bold px-4 py-2 rounded-full mb-6" data-id="element-199">
              🎓 KIT IMPERDIBLE
            </div>

            <h1 className="font-heading text-5xl md:text-6xl lg:text-7xl text-brand-navy leading-tight mb-6" data-id="element-200">
              COMBO EDUCATIVO <br data-id="element-201" />
              <span className="text-brand-blue" data-id="element-202">15 EN 1</span>
            </h1>

            <p className="text-xl md:text-2xl font-semibold text-slate-700 mb-4" data-id="element-203">
              Más de 550 páginas listas para imprimir que ayudan a los niños a
              aprender jugando.
            </p>

            <p className="text-base md:text-lg text-slate-600 mb-8" data-id="element-204">
              La colección educativa más completa para desarrollar lectura,
              escritura, matemáticas, creatividad y concentración desde casa o
              en el aula.
            </p>

            <ul className="space-y-3 mb-10 text-left inline-block lg:block" data-id="element-205">
              {['Acceso inmediato', 'Material imprimible', 'Actividades educativas listas para usar', 'Ideal para docentes y familias', 'Aprendizaje paso a paso'].map((item, i) => <motion.li key={i} initial={{
              opacity: 0,
              x: -20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: 0.3 + i * 0.1
            }} className="flex items-center gap-3 text-slate-700 font-medium text-lg" data-id="element-206">
                  <CheckCircle2 className="w-6 h-6 text-brand-green flex-shrink-0" data-id="element-207" />
                  {item}
                </motion.li>)}
            </ul>

            <div className="flex flex-col items-center lg:items-start gap-4" data-id="element-208">
              <Button size="xl" onClick={() => document.getElementById('oferta')?.scrollIntoView({
              behavior: 'smooth'
            })} className="group" data-id="element-209">
                <Rocket className="w-6 h-6 mr-2 group-hover:animate-bounce" data-id="element-210" />
                QUIERO EL KIT COMPLETO
              </Button>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 text-sm font-medium text-slate-500 mt-2" data-id="element-211">
                <span className="flex items-center gap-1" data-id="element-212">
                  <ShieldCheck className="w-4 h-4 text-brand-green" data-id="element-213" /> Pago
                  seguro
                </span>
                <span className="hidden sm:inline" data-id="element-214">•</span>
                <span className="flex items-center gap-1" data-id="element-215">
                  <Rocket className="w-4 h-4 text-brand-blue" data-id="element-216" /> Acceso
                  inmediato
                </span>
                <span className="hidden sm:inline" data-id="element-217">•</span>
                <span className="flex items-center gap-1 text-brand-orange" data-id="element-218">
                  <Star className="w-4 h-4 fill-brand-orange" data-id="element-219" /> 4.9/5 (2.300+
                  familias)
                </span>
              </div>
            </div>
          </motion.div>

          {/* Right Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-220">
            <Sticker type="star" className="top-10 -left-4 md:top-20 md:-left-10" delay={0.5} data-id="element-221" />
            <Sticker type="sparkle" className="bottom-20 -right-4 md:bottom-32 md:-right-8" delay={0.7} data-id="element-222" />
            <Sticker type="pencil" className="-top-6 right-10 md:-top-10 md:right-20" delay={0.9} data-id="element-223" />

            <motion.div animate={{
            y: [-10, 10, -10]
          }} transition={{
            repeat: Infinity,
            duration: 5,
            ease: 'easeInOut'
          }} className="relative z-20" data-id="element-224">
              <img src="https://cdn.shopify.com/s/files/1/0999/7487/3381/files/BUNDLE.png?v=1780592912&width=900&quality=90&format=webp" alt="Colección Aprendo y Me Divierto Bundle" width="900" height="900" loading="eager" fetchPriority="high" decoding="sync" className="w-full h-auto drop-shadow-2xl" data-id="element-225" />
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
};
export const SocialProof = () => <div className="bg-slate-50 border-y border-slate-100 py-6" data-id="element-226">
    <div className="max-w-7xl mx-auto px-4 flex flex-wrap justify-center items-center gap-8 md:gap-16 text-slate-600 font-semibold" data-id="element-227">
      <div className="flex items-center gap-2" data-id="element-228">
        <Users className="w-6 h-6 text-brand-blue" data-id="element-229" />
        <span data-id="element-230">+2.300 familias</span>
      </div>
      <div className="flex items-center gap-2" data-id="element-231">
        <Star className="w-6 h-6 text-brand-yellow fill-brand-yellow" data-id="element-232" />
        <span data-id="element-233">4.9★ valoración</span>
      </div>
      <div className="flex items-center gap-2" data-id="element-234">
        <CheckCircle2 className="w-6 h-6 text-brand-green" data-id="element-235" />
        <span data-id="element-236">+500 docentes</span>
      </div>
    </div>
  </div>;